export default __webpack_public_path__ + "b19ccbd241a3bfd9377d4066961b1620.png";